import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { VisibilityView } from 'pricing-pages-ui-components/components/VisibilityView';
import { jsx as _jsx } from "react/jsx-runtime";
const CurrentPlanButton = ({
  productLine,
  inlineSize,
  maxInlineSize,
  marginInline,
  visible,
  size
}) => {
  const message = productLine && `pricingPagesLib.comparisonFeatureTable.yourPlanCta.${productLine.toLowerCase()}` || window.location.href.includes('recommended') && 'pricingPagesLib.comparisonFeatureTable.ssm0010RecommendedCurrentPlan' ||
  // part of SSM0010 experiement for recommended pages
  'pricingPagesLib.comparisonFeatureTable.currentPlan';
  return /*#__PURE__*/_jsx(View, {
    inlineSize: inlineSize,
    maxInlineSize: maxInlineSize,
    marginInline: marginInline,
    children: /*#__PURE__*/_jsx(VisibilityView, {
      visible: visible,
      children: /*#__PURE__*/_jsx(Button, {
        disabled: true,
        block: true,
        size: size,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: message
        })
      })
    })
  });
};
export default CurrentPlanButton;